import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBomb,
  faBars,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faSearch,
  faShoppingCart,
  faFileArchive,
  faFileMusic,
  faFileVideo,
  faFileChartPie,
  faFileAlt,
  faFileSpreadsheet,
  faFilePdf,
  faFileImage,
  faFile,
  faMinus,
  faChevronLeft,
  faUserCircle,
  faSpinner,
  faExclamationCircle,
  faMapMarkerAlt,
  faCreditCard,
  faSyncAlt,
  faExternalLink,
  faArrowToTop,
  faCog,
  faHandHoldingSeedling,
  faHourglassStart,
  faQuestion,
  faCaretUp,
  faCaretDown,
} from "@fortawesome/pro-solid-svg-icons";

import { faAward, faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";

import {
  faTimes,
  faClock as faClockRegular,
  faCalendarAlt as faCalendarAltRegular,
  faTrashAlt,
  faEnvelopeOpenText,
  faPaperPlane,
  faFile as faFileRegular,
  faAngleRight,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faTimes as faTimesLight,
  faFileVideo as faFileVideoLight,
  faFileAlt as faFileAltLight,
  faFileDownload as faFileDownloadLight,
  faMapSigns,
  faHandHoldingSeedling as faHandHoldingSeedlingLight,
  faSeedling,
  faTree,
  faTools,
  faToolbox,
  faHome,
  faHeartRate,
  faClock,
  faBooks,
  faLayerGroup,
  faPrint as faPrintLight,
  faFilePdf as faFilePdfLight,
  faSave,
  faRandom,
  faShoppingBasket,
  faRocket,
  faTrashAlt as faTrashAltLight,
  faArrowsV as faArrowsVLight,
  faTimesCircle as faTimesCircleLight,
} from "@fortawesome/pro-light-svg-icons";

import {
  faYoutubeSquare,
  faLinkedin,
  faTwitterSquare,
  faFacebookSquare,
  faVimeoV,
  faTwitter,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

library.add( faAward );
library.add( faBomb );
library.add( faBars );
library.add( faCheck );
library.add( faChevronDown );
library.add( faChevronUp );
library.add( faChevronRight );
library.add( faChevronLeft );
library.add( faSearch );
library.add( faShoppingCart );
library.add( faFileArchive );
library.add( faFileMusic );
library.add( faFileVideo );
library.add( faFileChartPie );
library.add( faFileAlt );
library.add( faFileSpreadsheet );
library.add( faFilePdf );
library.add( faFileImage );
library.add( faFile );
library.add( faMinus );
library.add( faUserCircle );
library.add( faTimes );
library.add( faTimesLight );
library.add( faSpinner );
library.add( faYoutubeSquare );
library.add( faLinkedin );
library.add( faTwitterSquare );
library.add( faFacebookSquare );
library.add( faExclamationCircle );
library.add( faClockRegular );
library.add( faCalendarAltRegular );
library.add( faMapMarkerAlt );
library.add( faCreditCard );
library.add( faSyncAlt );
library.add( faTrashAlt );
library.add( faTrashAltLight );
library.add( faArrowsVLight );
library.add( faEnvelopeOpenText );
library.add( faPaperPlane );
library.add( faFileRegular );
library.add( faAngleRight );
library.add( faExternalLink );
library.add( faArrowToTop );
library.add( faCog );
library.add( faHandHoldingSeedling );
library.add( faFileVideoLight );
library.add( faFileAltLight );
library.add( faFileDownloadLight );
library.add( faCloudDownloadAlt );
library.add( faMapSigns );
library.add( faHourglassStart );
library.add( faRandom );
library.add( faQuestion );
library.add( faShoppingBasket );
library.add( faRocket );

library.add( faHandHoldingSeedlingLight );
library.add( faSeedling );
library.add( faTree );
library.add( faTools );
library.add( faToolbox );
library.add( faHome );
library.add( faHeartRate );
library.add( faClock );
library.add( faBooks );
library.add( faLayerGroup );

library.add( faPrintLight );
library.add( faFilePdfLight );

library.add( faSave );

library.add( faVimeoV );
library.add( faTwitter );
library.add( faLinkedinIn );
library.add( faYoutube );

library.add( faTimesCircleLight );

library.add( faCaretUp );
library.add( faCaretDown );
